<template>
    <div class="product-review-author-wrapper">
        <div class="product-review-author__name">
            <span>{{ result?.UF_USER || '' }}</span>
        </div>
        <time :datetime="result.date">{{ this.reviewDay }}</time>
        <div   class="product-review-author__rating">
            <meta :content="result.UF_RATING || ''">
                <span>{{ getStars }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProductReviewAuthor",
        props: ['result', 'messages'],
        data() {
            return {
                settings: {
                    months: {
                        ru: ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'],
                        ua: ['Січня', 'Лютого', 'Березня', 'Квітня', 'Травня', 'Червня', 'Липня', 'Серпня', 'Вересня', 'Жовтня', 'Листопада', 'Грудня'],
                    }
                },
            }
        },

        computed: {
            reviewDay() {
                const date = new Date(this.result.date);
                const month = date.getMonth();
                const year = date.getFullYear();
                return ("0" + date.getDate()).slice(-2) + ' ' + this.settings.months[this.result.LANGUAGE_ID][month] + ' ' + year;
                // return date.toLocaleString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric'})
            },
            getStars() {
                let stars = '';
                for (let i = 0; i < +this.result.UF_RATING; i++) { // выведет 0, затем 1, затем 2
                    stars += '★';
                }
                return stars;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .product-review-author-wrapper {
        font-family: Montserrat, sans-serif;

        time {
            font-size: rem(13);
            color: #333;
            background-color: #fff;
            line-height: 1.7;
            display: inline-block;
            width: 100px;
        }

        &__rating {
            > span {
                font-size: 11px;
                white-space: nowrap;
                color: #faa295;
                letter-spacing: 2px;
            }
        }
        &__name {
            font-weight: 500;
            overflow-wrap: break-word;
            max-width: 200px;
        }
    }
</style>